export default "/affiliate-links-banner.a49c7007-f09271.png";